export default "__VITE_ASSET__3ef61cb2__"